import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

const JurisdictionDropDown = ({ value, placeholder, className, onChange }) => {
  const { jurisdictions } = useSelector(state => state.common);

  const addCountryOption = (country) => {
    if (jurisdictions) {
      const filteredJurisdiction = jurisdictions.filter(x => x.name === country);
      if (filteredJurisdiction.length === 0) {
        return <option key={ country } disabled>{ country }</option>;
      }
    }
    return null;
  };

  return (<select className={ `col-5 form-select ${ className || '' }` } onChange={ e => onChange(e.target.value) } value={ value || '' }>
    <option value="">{ placeholder || 'Please select' }</option>
    { addCountryOption(value) }
    { jurisdictions && jurisdictions.map(x => (
      <option key={ x.name }>{ x.name }</option>
    )) }
  </select>);
};

JurisdictionDropDown.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

JurisdictionDropDown.defaultProps = {
  value: null,
  placeholder: '',
  className: ''
};

export default JurisdictionDropDown;
